import { render, staticRenderFns } from "./Cart-notify.vue?vue&type=template&id=a8010b9e&scoped=true&lang=pug"
import script from "./Cart-notify.vue?vue&type=script&lang=js"
export * from "./Cart-notify.vue?vue&type=script&lang=js"
import style0 from "./Cart-notify.vue?vue&type=style&index=0&id=a8010b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8010b9e",
  null
  
)

export default component.exports